import { render, staticRenderFns } from "./BalanceDetail.vue?vue&type=template&id=58b59f56&scoped=true"
import script from "./BalanceDetail.vue?vue&type=script&lang=js"
export * from "./BalanceDetail.vue?vue&type=script&lang=js"
import style0 from "./BalanceDetail.vue?vue&type=style&index=0&id=58b59f56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b59f56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b59f56')) {
      api.createRecord('58b59f56', component.options)
    } else {
      api.reload('58b59f56', component.options)
    }
    module.hot.accept("./BalanceDetail.vue?vue&type=template&id=58b59f56&scoped=true", function () {
      api.rerender('58b59f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialManagement/memberBalanceDetails/components/BalanceDetail.vue"
export default component.exports